import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: '#ffffff',
        color: '#1f2937'
      }
    }
  },
  colors: {
    blue: {
      50: '#eaf5fb',
      100: '#d6ebf8',
      200: '#aad7f1',
      300: '#7ec3ea',
      400: '#53afe3',
      500: '#3498db',
      600: '#2e86c1',
      700: '#2874a6',
      800: '#1f5a82',
      900: '#154360',
    },
  }
});

export default theme 
